<template>
    <div v-if="!(mobile && store.active === false)" @click.stop.prevent="openStore" class="card mr-0 sm:mr-2 mb-1 sm:mb-2 px-1 py-2 card-store cursor-pointer transition duration-200 rounded shadow-none border border-gray-300 hover:border-gray-500 text-center flex align-middle justify-center items-center w-1/2 sm:w-64" class2="border-2 w-full">
        <div class2="px-0 py-0 sm:px-2 sm:py-2">
            <a :href="store.link" target="_blank" rel="nofollow">
                <img v-if="logoUrl" :data-src="logoUrl" :alt="store.name" class="lazyload inline store-image">
                <span v-if="!logoUrl" class="font-semibold">
                    {{ store.name }}
                </span>
            </a>
        </div>

        <!-- <div v-if="store.active === false" class="mt-2 text-xs text-gray-600"> -->
            <!-- <span v-if="store.active === true">
                Tracking {{ store.listings_count }} listings
            </span> -->
            <!-- <span class="badge badge-light text-xs">Coming Soon</span> -->
        <!-- </div> -->
    </div>
</template>

<script>
import StoreMixin from '../../mixins/store';

export default {
    mixins: [StoreMixin],

    props: ['store'],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {
        logoUrl() {
            if (this.store.network === 'amazon2') {
                return null;
            }

            return this.store.logo_url;
        }
    },

    methods: {}
}
</script>

<style lang="scss" scoped>
.card-store {
    height: 64px;
}

.store-image {
    max-height: 35px;
    // max-width: 100%;
    max-width: 115px;
    width: auto;
}
</style>
